import Divider from '@portalterreno/react-ui-core/Divider';
import AccountBalanceWalletOutlinedIcon from '@portalterreno/react-ui-icons/AccountBalanceWalletOutlinedIcon';
import HomeIcon from '@portalterreno/react-ui-icons/HomeIcon';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import React, { memo } from 'react';

import StyledDivList from './StyledDivList';
import StyledListItem from './StyledListItem';

export type MenuMobileListProps = React.HTMLAttributes<HTMLDivElement>;

const MenuMobileList: React.FC<MenuMobileListProps> = ({ ...rest }) => {
  const { t } = useTranslation('common');
  return (
    <StyledDivList {...rest}>
      <Link href={process.env.NEXT_PUBLIC_LEGACY_HOST}>
        <StyledListItem leftIcon={<HomeIcon />}>Inicio</StyledListItem>
      </Link>
      <Divider />
      <Link
        href={`${process.env.NEXT_PUBLIC_LEGACY_HOST}/${process.env.NEXT_PUBLIC_COUNTRY}/planes`}
      >
        <StyledListItem leftIcon={<AccountBalanceWalletOutlinedIcon />}>
          {t('plans')}
        </StyledListItem>
      </Link>
      <Divider />
    </StyledDivList>
  );
};

export default memo(MenuMobileList);
